<lib-confirmation-setting-condition [entity]="entity"></lib-confirmation-setting-condition>